import React, { Component } from "react";
import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import matchSorter from "match-sorter";
import { Row, Col } from "react-bootstrap";
import moment from "moment";

import Sidebar from "../commonAdmin/Sidebar";
import Header from "../commonAdmin/Header";
import Footer from "../commonAdmin/Footer";
import delivaApiService from "../../../common/services/apiService";
import Pagination from "../DeliveryAgent/perfectpage";
import Loader from "../../common/Loader";

class OpenDeliveryRequests extends Component {
  constructor() {
    super();
    this.state = {
      name: "React",
      searchInput: "",
      details: [],
      data: [],
      defaultPageSize: 5,
      resized: [{ id: "default", value: 5 }],
      pageSize: 5,
      apiname: "",
      showLoader: false, // Added
      sorted: [],
      pages: 0,
      currentPage: 0,
    };
    this.filterAll = this.filterAll.bind(this);
  }

  componentDidMount() {
    this.getListOfOpenRequests(1, this.state.pageSize);
  }

  handleRouteChange(val) {
    this.props.history.push(val);
  }

  textFilter(filter, row) {
    let result = parseInt(
      row[filter.id].toUpperCase().indexOf(filter.value.toUpperCase()),
      10
    );
    if (result < 0) {
      return false;
    } else {
      return true;
    }
  }
  setLoader(showLoader) {
    this.setState({
      showLoader,
    });
  }

  onFilteredChange(filtered) {
    if (filtered.length > 1 && this.state.filterAll.length) {
      const filterAll = "";
      this.setState({
        filtered: filtered.filter((item) => item.id != "all"),
        filterAll,
      });
    } else this.setState({ filtered });
  }

  onRezise(page) {
    console.log(page);
  }

  detailsPage = (id) => {    
    this.props.history.push(`/opendeliveryrequestsdetails/${id}`, id);
  };

  filterAll(e) {
    const { value } = e.target;
    const filterAll = value;
    const filtered = [{ id: "all", value: filterAll }];
    this.setState({ filterAll, filtered });
  }

  handleChange = (event) => {
    let value = event.target.value;
    let trimmedValue = value.replace(/\s+/g, " ").trimStart();
    this.setState({ searchInput: trimmedValue }, () => {
      this.globalSearch();
    });
  };

  globalSearch = () => {
    let { searchInput } = this.state;
    let filteredData = this.state.details.filter((value) => {
      return (
        value?.packageName
          ?.toLowerCase()
          .includes(searchInput?.toLowerCase()) ||
        value?.destinationLocation
          ?.toLowerCase()
          ?.includes(searchInput?.toLowerCase()) ||
        value?.orderId?.toString()?.includes(searchInput)
      );
    });
    this.setState({ data: filteredData });
  };

  getListOfOpenRequests(pageNumber = 1, records) {
    this.setLoader(true);
    delivaApiService("getListOfOpenRequests", {pageNumber: pageNumber, records: records})
      .then((response) => {
        if (response && response.data && response.data.resourceData) {
          this.setLoader(false);
          this.setState(
            {
              details: response.data.resourceData.data,
              totalCount: response.data.totalRecords,
              pageSize: records || this.state.pageSize,
              currentPage: pageNumber - 1,
            },
            () => {
              this.setState({
                data: this.state.details,
                pages: Math.ceil(this.state.totalCount / this.state.pageSize),
              });
            }
          );
        }
      })
      .catch((err) => {
        this.setLoader(false);
      });
  }

  onChangeItemPerPage(pageSize) {
    this.setState({ pageSize });
  }

  onEnterPerPage(e) {
    if (e.key === 'Enter') {
      const val = e.target.value;
      if (val && val > 0) {
        this.getListOfOpenRequests(1, val);
      }
    }
  }

  handleSortChange = (newSorted) => {
    this.setLoader(true);
    this.setState({ sorted: newSorted }, () => {
      setTimeout(() => {
        this.setLoader(false);
      }, 500); // brief delay to show loader
    });
  };

  render() {
    const columns = [
      {
        Header: () => (
          <span className="d-flex align-items-center">
            Request ID{" "}
            <span className="icon-up-and-down openDeliveryRequestIcon"></span>
          </span>
        ),
        id: "orderId",
        accessor: (d) => d.orderId,
        Cell: (props) => (
          <div>
            <div>#{props.value}</div>
            {props.original.isBundle && (
              <span className="bundle-badge">BUNDLE</span>
            )}
          </div>
        ),
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["orderId"] }),
        filterAll: true,
        resizable: false,
      },
      {
        Header: () => (
          <span className="d-flex align-items-center">
            Request Date{" "}
            <span className="icon-up-and-down openDeliveryRequestIcon"></span>
          </span>
        ),
        id: "orderDate",
        accessor: (d) => moment(new Date(d.orderDate)).format("DD MMM YYYY"),
        Cell: (props) => <span>{props.value}</span>,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["requestId"] }),
        filterAll: true,
        resizable: false,
      },
      {
        Header: () => (
          <span className="d-flex align-items-center">
            Package Name{" "}
            <span className="icon-up-and-down openDeliveryRequestIcon"></span>
          </span>
        ),
        id: "packageName",
        accessor: (d) => d.packageName,
        Cell: (props) => <span>{props.value}</span>,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["packageName"] }),
        filterAll: true,
        resizable: false,
      },
      {
        Header: () => (
          <span className="d-flex align-items-center">
            Package Weight{" "}
            <span className="icon-up-and-down openDeliveryRequestIcon"></span>
          </span>
        ),
        id: "packageWeight",
        accessor: (d) => d.packageWeight,
        Cell: (props) => <span>{props.value}</span>, // Custom cell components!
        // accessor: "deliveryAgentName", // String-based value accessors!
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["packageWeight"] }),
        filterAll: true,
        resizable: false,
      },
      {
        Header: () => (
          <span className="d-flex align-items-center">
            Pickup{" "}
            <span className="icon-up-and-down openDeliveryRequestIcon"></span>
          </span>
        ),
        id: "pickUpLocation",
        accessor: (d) => d.pickUpLocation,
        Cell: (props) => <span>{props.value}</span>, // Custom cell components!
        // accessor: "pickUpLocation", // String-based value accessors!
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["pickUpLocation"] }),
        filterAll: true,
        resizable: false,
      },
      {
        Header: () => (
          <span className="d-flex align-items-center">
            Drop-off{" "}
            <span className="icon-up-and-down openDeliveryRequestIcon"></span>
          </span>
        ),
        id: "destinationLocation",
        accessor: (d) => d.destinationLocation,
        Cell: (props) => (
          <span>
            {props.value}
            {props.original?.dropOffCount > 0 ? (
              <span className="drop-off-count">
                +{props.original.dropOffCount}
              </span>
            ) : null}
          </span>
        ),
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["destinationLocation"] }),
        filterAll: true,
        resizable: false,
      },

      {
        Header: () => (
          <span className="d-flex justify-content-center">
            Action{" "}
            {/* <span className="icon-up-and-down openDeliveryRequestIcon"></span> */}
          </span>
        ),
        id: "Action",
        // accessor: (d) => d.packageWeight,
        Cell: (props) => {
          return (
            <div className="d-flex justify-content-center">
              <span
                title="View"
                className="icon-eye pointer"
                onClick={() => this.detailsPage(props?.original?.orderId)}
              />
            </div>
          );
        }, // Custom cell components!
        // accessor: "deliveryAgentName", // String-based value accessors!
        // filterMethod: (filter, rows) =>
        //   matchSorter(rows, filter.value, { keys: ['packageWeight'] }),
        filterAll: false,
        resizable: false,
      },

      {
        Header: "All",
        id: "all",
        width: 0,
        show: false,
        resizable: false,
        sortable: false,
        Filter: () => {},
        getProps: () => {
          return {};
        },
        filterMethod: (filter, rows) => {
          console.log(filter);
          console.log(rows);
          const result = matchSorter(rows, filter.value, {
            keys: [
              "orderId",
              "destinationLocation",
              "orderDate",
              "pickUpLocation",
            ],
            threshold: matchSorter.rankings.WORD_STARTS_WITH,
          });
          console.log("row[0]:", result[0]);
          return result;
        },
        filterAll: true,
      },
    ];
    return (
      <div className="page__wrapper h-100">
        <Header {...this.props} />

        <div className="mainContainer CustomerTable">
          <Row noGutters className="h-100">
            <Sidebar {...this.props} />
            <Col md={9} lg={10} className="boxTyp3">
              <div className="container-fluid">
                <div className="content-wrapper">
                  <Row noGutters className="mb-3">
                    <Col>
                      <h3 className="font-weight-normal mb-0 line-ht color-33 fs-24 fs22">
                        Open Delivery Requests
                        <span className="color-grey">
                          ({this.state.totalCount})
                        </span>
                      </h3>
                      <h5 className="font-weight-normal mb-0 line-ht fs18 color-head">
                        <span
                          className="pointer"
                          onClick={() => this.handleRouteChange("/dashboard")}
                        >
                          Dashboard
                        </span>
                        <span className="icon-next mx-2 Fs12"></span>
                        Open Delivery Requests
                      </h5>
                    </Col>
                    <Col md="auto" className="text-right">
                      <input
                        name="searchInput"
                        value={this.state.searchInput || ""}
                        onChange={this.handleChange}
                        label="Search"
                        type="text"
                        placeholder="Search by Request ID, Location"
                        className="searchTxt w-100"
                      />
                      <span className="icon-search"></span>
                    </Col>
                  </Row>

                  <div className="row ">
                    <div className="col-sm-12">
                      <div className="custom-reactTable openDeliveryRequestTable">
                        {/* table-wrap open-delivery-table */}
                        <ReactTable
                          data={this.state.data}
                          columns={this.state.pageSize ? columns : columns}
                          manual={true}
                          defaultPageSize={this.state.defaultPageSize}
                          pages={this.state.pages}
                          page={this.state.currentPage}
                          pageSize={this.state.pageSize}
                          showPageSizeOptions={true}
                          filtered={this.state.filtered}
                          ref={(r) => (this.reactTable = r)}
                          onFilteredChange={this.onFilteredChange.bind(this)}
                          onPageChange={(pageIndex) => {
                            this.getListOfOpenRequests(pageIndex + 1, this.state.pageSize);
                          }}
                          onPageSizeChange={(pageSize, pageIndex) => {
                            this.setState({ pageSize }, () => {
                              this.getListOfOpenRequests(pageIndex + 1, pageSize);
                            });
                          }}
                          sorted={this.state.sorted}
                          onSortedChange={this.handleSortChange}
                          defaultFilterMethod={(filter, row) =>
                            String(row[filter.age]) === filter.value
                          }
                          PaginationComponent={
                            this.state.data.length > 0 ? Pagination : () => null
                          }
                          NoDataComponent={() => (
                            <div className="text-center bg-white text-grey py-3">
                              No Records Available
                            </div>
                          )}
                        />

                        {this.state.data.length > 0 && (
                          <span className="page-value">
                            Enter Per Page
                            <input
                              type="text"
                              placeholder="07"
                              name="defaultPageSize"
                              value={this.state.pageSize}
                              onChange={(e) => this.onChangeItemPerPage(e.target.value)}
                              onKeyDown={(e) => this.onEnterPerPage(e)}
                            />
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer {...this.props} />
            </Col>
          </Row>
        </div>
        <Loader showLoader={this.state.showLoader} />
      </div>
    );
  }
}
export default OpenDeliveryRequests;
